import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useCart, useGTM } from 'lib/core/hooks'
import { CheckoutDescription, CheckoutStep } from 'lib/core/services/gtm'
import { Disabler } from 'lib/ui'
import {
  useCheckout,
  Styled,
  Nav,
  Totals,
  EmailForm,
  PlaceOrder,
  PaymentMethods,
  PaymentOptions,
  BillingAddress
} from 'lib/modules/checkout'

export const BillingScene = () => {
  const { cart } = useCart()
  const {
    validateShippingAddress,
    validateShippingMethod,
    requiresShipping,
    orderTotal,
    billingAddress
  } = useCheckout()
  const history = useHistory()
  const isValid = validateShippingAddress() && validateShippingMethod()
  const needsShipping = requiresShipping()
  const { triggerCheckout } = useGTM()

  useEffect(() => {
    if (!isValid) {
      history.replace('/checkout/shipping')
    }
  }, [isValid, history])

  useEffect(() => {
    triggerCheckout({ cart, step: CheckoutStep.Payment, description: CheckoutDescription.Payment })
  }, [triggerCheckout, cart])

  return (
    <>
      <Nav />
      <Styled.Container>
        <h1>
          Payment & Billing Information
        </h1>
        <Styled.CheckoutLayout>
          <Styled.CheckoutMain>
            {!!orderTotal && (
              <Disabler disabled={billingAddress.isFetching}>
                <PaymentOptions />
                <PaymentMethods />
              </Disabler>
            )}

            {!needsShipping && (
              <EmailForm />
            )}

            <h2>
              Billing Address
            </h2>

            <Styled.MainFormContainer>
              <BillingAddress />
            </Styled.MainFormContainer>
          </Styled.CheckoutMain>
          <Styled.CheckoutAside>
            <div>
              <Totals />
              <PlaceOrder />
            </div>
          </Styled.CheckoutAside>
        </Styled.CheckoutLayout>
      </Styled.Container>
    </>
  )
}
